export default __webpack_public_path__ + "e4c17382a614113b57c1b89e54aeea48.png";